/* eslint-disable no-unused-vars */
export class AbstractValidator {

    /**
     * @return {string} Returns a unique identifier used when registering the validator
     */
    static getIdentifier() {
        throw new ReferenceError('Validators must implement `getIdentifier`');
    }

    /**
     * @param {HTMLInputElement} input
     * @param {ValidationInstance} validationInstance
     */
    static isApplicable(input, validationInstance) {
        return !input.hidden;
    }

    /**
     * @param {HTMLInputElement} input
     * @param {ValidationInstance} validationInstance
     */
    static validate(input, validationInstance) {
        throw new ReferenceError('Not implemented abstract method `validate`');
    }
}
